import React, { useContext, type Ref } from 'react';
import Select from 'react-select';
import { getSelectStylesV2, getSelectTheme } from './getSelectStyles';
import { ThemeContext } from 'styled-components';

/**
 * A prestyled version of react-select https://github.com/JedWatson/react-select
 * @param props
 * @constructor
 */
// @ts-expect-error: fixme
const VennSelect = React.forwardRef(function VennSelect<T, IsMulti extends boolean>(props, ref: Ref<Select>) {
  const { Colors } = useContext(ThemeContext);
  const { menuPortalZIndex, menuPortalScrollContainer, ...rest } = props;
  return (
    <Select
      aria-label="venn-select"
      ref={ref}
      theme={getSelectTheme(Colors, rest.refreshedStyling)}
      styles={getSelectStylesV2<T, IsMulti>(
        Colors,
        rest.darkPlaceholder,
        rest.maxHeight,
        rest.refreshedStyling,
        menuPortalZIndex,
        menuPortalScrollContainer,
      )}
      {...rest}
    />
  );
});

export default VennSelect;
